'use client';

import { useMemo } from 'react';

import { getCopilotAccess } from '@/lib/copilot-access';
import { useUserStore } from '@/store/user';
import { authSelectors } from '@/store/user/selectors';
import { useWorkspaceStore } from '@/store/workspace';

export function useCopilotAccess() {
  const screens = useUserStore(authSelectors.screens);
  const features = useUserStore(authSelectors.features);
  const entitlementsStatus = useUserStore(authSelectors.entitlementsStatus);
  const entitlementsWorkspaceId = useUserStore(authSelectors.entitlementsWorkspaceId);
  const selectedWorkspaceId = useWorkspaceStore(s => s.selectedWorkspace?.workspace_id);

  return useMemo(
    () =>
      getCopilotAccess(
        {
          workspaceId: entitlementsWorkspaceId,
          status: entitlementsStatus,
          screens,
          features,
        },
        selectedWorkspaceId
      ),
    [entitlementsStatus, entitlementsWorkspaceId, features, screens, selectedWorkspaceId]
  );
}
